import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { CreditsInfosBlock } from './CreditsInfosBlock';

const useStyles = createUseStyles((theme: Theme) => ({
  infosContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    padding: theme.marginBase * 3,
    gap: theme.marginBase * 5 + 'px',
    [theme.media.tablet]: {
      flexDirection: 'column',
    },
  },
  infoBlockContainer: {
    flex: 1,
  },
}));

interface Props {
  className?: string;
}

export const CreditsInfosSection = ({ className }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classnames(classes.infosContainer, className)}>
      <div className={classes.infoBlockContainer}>
        <CreditsInfosBlock
          icon="ri-time-line"
          title={t('billing.emptyPage.infosBlock.time.title')}
          text={t('billing.emptyPage.infosBlock.time.description')}
        />
      </div>
      <div className={classes.infoBlockContainer}>
        <CreditsInfosBlock
          icon="ri-coins-line"
          title={t('billing.emptyPage.infosBlock.money.title')}
          text={t('billing.emptyPage.infosBlock.money.description')}
        />
      </div>
      <div className={classes.infoBlockContainer}>
        <CreditsInfosBlock
          icon="ri-user-3-line"
          title={t('billing.emptyPage.infosBlock.team.title')}
          text={t('billing.emptyPage.infosBlock.team.description')}
        />
      </div>
    </div>
  );
};
